import { render, staticRenderFns } from "./BusinessAccountManager.vue?vue&type=template&id=f1c321ae&scoped=true"
import script from "./BusinessAccountManager.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessAccountManager.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BusinessAccountManager.vue?vue&type=style&index=0&id=f1c321ae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c321ae",
  null
  
)

export default component.exports